import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from './store';
import Cookies from 'js-cookie';
import {buildUserFromToken} from "@/lib/build-user-from-token";
import {clearTokenRefresh} from "@/lib/schedule-token-refresh";
import User from '@/types/user';


interface UserState {
    currentUser: User | null;
    userId: string | null;
    isLoggingOut: boolean;
    photoFile: File | null;
}

const initialState: UserState = {
    currentUser: null,
    userId: null,
    isLoggingOut: false,
    photoFile: null,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setCurrentUser: (state, action: PayloadAction<User | null>) => {
            if (action.payload !== null) {
                const prevUser = state.currentUser;

                const user = buildUserFromToken(
                    action.payload.jwtToken,
                    prevUser ?? action.payload
                );

                state.userId = user.id;
                state.currentUser = {
                    ...user,
                    picture: prevUser?.picture ?? user.picture,
                };


                Cookies.set("token", user.jwtToken, {
                    path: "/",
                    sameSite: "lax",
                    secure: process.env.NODE_ENV === "production",
                    expires: 1,
                });

                Cookies.set("user",
                    encodeURIComponent(JSON.stringify(state.currentUser)),
                    {
                        path: "/",
                        sameSite: "lax",
                        secure: process.env.NODE_ENV === "production",
                        expires: 1,
                        
                    }
                );


            } else {
                clearTokenRefresh();
                Cookies.remove("user");
                Cookies.remove("token");
                state.currentUser = null;
                state.userId = null;
            }
        },

        setIsLoggingOut(state, action: PayloadAction<boolean>) {
            state.isLoggingOut = action.payload;
        },
        setPhotoFile: (state, action: PayloadAction<File | null>) => {
            state.photoFile = action.payload;
        },
    },
});

export const {setCurrentUser, setIsLoggingOut, setPhotoFile} = userSlice.actions;
export const selectUser = (state: RootState) => state.user.currentUser;
export const selectPhotoFile = (state: RootState) => state.user.photoFile;
export default userSlice.reducer;
